import packConfig from "@/config/packConfig";

const setHighestPriorityPackage = (storeObj: any) => {
    const { getters, dispatch } = storeObj

    const availablePackCodes = getters.availablePackCodes;

    for (const packCode of packConfig) {
        const isPackageFromPackConfigAvailable = !!availablePackCodes.find((packObj: any) => {
            return packObj.codePackage === packCode;
        });
        if (isPackageFromPackConfigAvailable) {
            dispatch("setPackage", packCode);
            break;
        }
    }
}

export default setHighestPriorityPackage